import { useMemo } from 'react';
import { useChannelStateContext, useChatContext } from 'stream-chat-react';
import { FAIcon } from '~/components/utils/FAIcons';
import { useStreamChatContext } from '~/react_context/StreamChatContext';

export const TeamChannelHeader = () => {
	const { client, setActiveChannel } = useChatContext();
	const { channel, members } = useChannelStateContext();
	const { onAddUsersToChannelClick, onChannelListChange, onEditChannelClick } = useStreamChatContext();
	const otherChannelMembers = useMemo(
		() => (members ? Object.values(members).filter(({ user }) => user !== undefined && user.id !== client.userID) : []),
		[members]
	);
	const { data: channelData } = channel;

	if (!channelData || !members) {
		return null;
	}

	const channelDisplayName = channelData.name ?? 'unknown-channel';

	const getMessagingHeader = () => {
		if (!otherChannelMembers.length) {
			return null;
		}

		const additionalMemberCount = otherChannelMembers.length - 2;
		const displayedMemberNames = otherChannelMembers
			.slice(0, 2)
			.map((channelMemberResponse) => channelMemberResponse.user?.name ?? 'Unknown User');
		const parts = [...displayedMemberNames, additionalMemberCount > 0 ? `${additionalMemberCount} more` : null].filter(Boolean);

		return <div>{parts.join(', ')}</div>;
	};

	const confirmLeaveChannel = async () => {
		if (confirm(`Do you really want to leave ${channel.type === 'messaging' ? 'this conversation' : `"${channelDisplayName}"`}?`)) {
			await channel.removeMembers([client.userID!]);
			setActiveChannel();
			onChannelListChange();
		}
	};

	return (
		<div className="flex items-center justify-between border-b pb-1">
			{channel.type === 'messaging' ? (
				getMessagingHeader()
			) : (
				<button
					className="text-primary hover:text-primary-dark truncate ..."
					onClick={onEditChannelClick}
					type="button"
				>{`# ${channelDisplayName}`}</button>
			)}
			<div className="shrink-0 flex gap-4 px-2">
				{members[client.userID!] && (
					<>
						{channel.type === 'team' && (
							<button type="button" className="text-sm text-primary shrink-0" onClick={onAddUsersToChannelClick} title="Add Users">
								<FAIcon icon="user-plus" />
							</button>
						)}
						<button type="button" className="text-sm text-red-500 shrink-0" onClick={confirmLeaveChannel} title="Leave Channel">
							<FAIcon icon="right-from-bracket" />
						</button>
					</>
				)}
				<div className="bg-gray-200 px-2 py-1 rounded-md text-xs text-gray-500 shrink-0">
					<FAIcon icon="user" /> {otherChannelMembers.length + 1}
				</div>
			</div>
		</div>
	);
};
